import { useContext } from "react";
import { BusinessTypeContext } from "hooks/useBizTypeTranslation";

export const useBizType = () => {
  const businessType = useContext(BusinessTypeContext);

  const bizTypeCheck = (types) => {
    return types?.includes(businessType);
  };

  return { bizTypeCheck };
};
